import type { CameraResponse } from "../../lib/api";
import styles from "./ReportsPanel.module.css";

type CameraPickerProps = {
  cameras: CameraResponse[];
  selected: string[]; // empty = every camera
  onChange: (selected: string[]) => void;
};

export const CameraPicker = ({ cameras, selected, onChange }: CameraPickerProps) => {
  const toggle = (id: string) =>
    onChange(selected.includes(id) ? selected.filter((s) => s !== id) : [...selected, id]);
  const label =
    selected.length === 0
      ? `Cameras: All (${cameras.length})`
      : `Cameras: ${selected.length} of ${cameras.length}`;

  return (
    <details className={styles.cameraPicker}>
      <summary className="form-select">{label}</summary>
      <div className={styles.cameraList}>
        {cameras.map((camera) => (
          <label key={camera.id} className={styles.check}>
            <input
              type="checkbox"
              checked={selected.includes(camera.id)}
              onChange={() => toggle(camera.id)}
            />
            {camera.name}
          </label>
        ))}
        {selected.length > 0 && (
          <button type="button" className={styles.linkButton} onClick={() => onChange([])}>
            All cameras
          </button>
        )}
      </div>
    </details>
  );
};
